import React, { useEffect, useState } from 'react';
import Loader from '../Loader/Loader';
import Avtar from "../../Images/avatar.png"
import { getUsers } from '../../Web Apis/Apis';
import { message, Pagination } from 'antd';

function InActiveUsers() {
    const [loading, setLoading] = useState(false)
    const [allActiveUsers, setAllActiveUsers] = useState([])


    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentUser = allActiveUsers.slice(indexOfFirstItem, indexOfLastItem);

    const fetchActiveUsers = async () => {
        try {
            setLoading(true)

            const response = await getUsers()
            if (response?.data?.success) {
                const filterData = response?.data?.data?.filter((item) => item?.active === false)

                const reverseData = filterData.reverse()

                setAllActiveUsers(reverseData)

                console.log("RevrseData", filterData)
            }

        } catch (error) {
            console.log("Admin fetch error", error.message)
            if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                // Handle internet disconnection
                return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
                window.alert("Your account is logged in to another device, please login again !")
                localStorage.clear();
                window.location.href = "/login"
            }
            if (error?.response?.status === 500) {
                message.error("Server not responding")
            }
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        fetchActiveUsers();
    }, [])


    return (
        <div className='p-4'>

            <div className="flex justify-between items-center w-full space-x-4">
                {/* Search Input Container */}
                <h3 className='text-3xl font-bold'>Inactive Users</h3>

            </div>

            <table className='min-w-full mt-7 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black'>
                <thead>
                    <th className="py-2 px-4 border-b text-center">S.No</th>
                    <th className="py-2 px-4 border-b text-center">Profile Img</th>
                    <th className="py-2 px-4 border-b text-center">Full Name</th>

                    <th className="py-2 px-4 border-b text-center">Email</th>
                    <th className="py-2 px-4 border-b text-center">Phone</th>
                    <th className="py-2 px-4 border-b text-center">Marketing & Comm</th>
                    <th className="py-2 px-4 border-b text-center">Status</th>
                    {/* <th className="py-2 px-4 border-b text-center">Actions</th> */}
                </thead>

                <tbody>
                    {currentUser?.length > 0 ? (
                        currentUser?.map((user, index) => (
                            <tr key={user.id}
                                className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                            >
                                <td className='py-2 px-4 border-b'>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                                <td className="py-2 px-4 border-b flex justify-center">
                                    <img
                                        src={user?.profileImageUrl || Avtar}
                                        alt="user"
                                        className="w-30 h-30 object-cover border border-gray-700"
                                        style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                                    />
                                </td>

                                <td className="py-2 px-4 border-b">{user.firstName} {user.lastName}</td>

                                <td className="py-2 px-4 border-b">{user.email}</td>
                                <td className="py-2 px-4 border-b">{user.phone}</td>
                                <td className={`py-2 px-4 border-b font-bold ${user.marketingCommunication ? 'text-green-600' : 'text-red-500'}`}>{user.marketingCommunication ? "ON" : "OFF"}</td>
                                <td className="py-2 px-4 border-b">
                                    <span className={`py-0.5 px-2 text-[20px] font-medium w-fit ${user.active ? "text-green-500" : "text-red-500"}`}>
                                        {user.active ? "Active" : "Inactive"}
                                    </span>
                                </td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No active user data found</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {loading && <Loader />}

            <div className="mt-4 flex justify-end">
                <Pagination
                    current={currentPage}
                    total={allActiveUsers.length}
                    pageSize={itemsPerPage}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                />
            </div>

        </div>
    )
}

export default InActiveUsers